{
  "pages": {
    "BulkSupplierUpload": {
      "back_to_suppliers": "Back to Suppliers",
      "bulk_upload_suppliers": "Bulk Upload Suppliers",
      "upload_a_csv_file_to_add": "Upload a CSV file to add multiple suppliers at once.",
      "download_template": "Download template",
      "use_this_csv_template_to_format": "Use this CSV template to format your supplier data\n                      correctly. All required fields are marked.",
      "download_csv": "Download CSV",
      "or_click_to_browse": "or click to browse",
      "supported_csv": "Supported: .csv",
      "upload_error": "Upload error",
      "expected_fields": "Expected fields",
      "rows_total": "rows total",
      "valid": "valid",
      "with_errors": "with errors",
      "upload_different_file": "Upload different file",
      "row": "row",
      "with_validation_errors": "with validation errors",
      "these_rows_have_issues_and_will": "These rows have issues and will not be imported. Fix them in\n                    your file or remove them below.",
      "type": "Type",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "tax_id": "Tax ID",
      "province": "Province",
      "payout": "Payout",
      "all_rows_have_been_removed_upload": "All rows have been removed. Upload a different file to try\n                  again.",
      "cancel": "Cancel",
      "import": "Import",
      "supplier": "supplier",
      "suppliers_imported_successfully": "Suppliers imported successfully",
      "been_added_to_your_account": "been added to your\n                account.",
      "upload_more": "Upload more",
      "go_to_suppliers": "Go to Suppliers"
    },
    "SupplierDetail": {
      "all_suppliers": "All suppliers",
      "you_owe_them": "You owe them:",
      "add_bill": "Add bill",
      "details": "Details",
      "edit": "Edit",
      "company": "Company",
      "individual": "Individual",
      "company_name_local": "Company name (Local)",
      "company_name_english": "Company name (English)",
      "tax_id_registration_no": "Tax ID / Registration no.",
      "branch": "Branch",
      "vat_registered": "VAT registered",
      "contact_person": "Contact person",
      "full_name_thai": "Full name (Malay)",
      "full_name_english": "Full name (English)",
      "id_type": "ID type",
      "id_number": "ID number",
      "billing_email": "Billing email",
      "address": "Address",
      "internal_reference": "Internal reference",
      "payin_method": "Pay-in method",
      "cardholder": "Cardholder",
      "card_number": "Card number",
      "payout_method": "Payout method",
      "edit_payout_method": "Edit payout method",
      "bank_account": "Bank Account",
      "direct_transfer": "Direct transfer",
      "bank_name": "Bank name",
      "account_number": "Account number",
      "account_name": "Account name",
      "promptpay": "PromptPay",
      "promptpay_id": "PromptPay ID",
      "display_name": "Display name",
      "source": "Source",
      "platform": "Platform",
      "date_created": "Date created",
      "bills": "Bills",
      "bill": "bill",
      "for": "for",
      "due": "due,",
      "awaiting_approval": "awaiting approval,",
      "scheduled_and": "scheduled and",
      "paid": "paid.",
      "history": "History"
    },
    "SupplierForm": {
      "supplier_information": "Supplier Information",
      "enter_details_myself": "Enter details myself",
      "fill_in_supplier_identity_contact_and": "Fill in supplier identity, contact, and payout details\n                        on their behalf",
      "invite_supplier": "Invite supplier",
      "generate_a_secure_link_for_the": "Generate a secure link for the supplier to input their\n                        own details",
      "tax_id_registration_number": "Tax ID / Registration Number *",
      "attrs": {
        "13digit_registration_number": "13-digit registration number",
        "enter_email_address": "Enter email address",
        "eg_0812345678": "e.g. 0812345678",
        "address_line_1": "Address line 1",
        "address_line_2": "Address line 2",
        "eg_khlong_toei": "e.g. Henveiru",
        "select_province": "Select province",
        "postcode_5_digits": "Postcode (5 digits)",
        "enter_internal_reference": "Enter internal reference",
        "select_a_bank": "Select a bank",
        "1012_digits": "10–12 digits",
        "name_on_the_bank_account": "Name on the bank account",
        "eg_siam_fresh_market": "e.g. KL Fresh Market",
        "your_name_as_it_appears_on": "Your name as it appears on the card",
        "xxxx_xxxx_xxxx_xxxx": "XXXX XXXX XXXX XXXX",
        "mmyy": "MM/YY"
      },
      "lookup": "Lookup",
      "company_details_fetched_from_department_of": "Company details fetched from Department of\n                                Business Development (DBD)",
      "registered": "Registered:",
      "note": "Note:",
      "direct_browser_request_to_dbd_api": "Direct browser request to DBD API was blocked by\n                                CORS. Showing mock data. In production, route\n                                API calls through your backend proxy.",
      "company_name_local": "Company name (Local) *",
      "branch_number": "Branch number *",
      "contact_person_name": "Contact person name",
      "vat_registered_company": "VAT registered company",
      "thai_citizen_id": "MyKad (NRIC)",
      "passport": "Passport",
      "full_name_local": "Full name (Local)",
      "full_name": "Full name *",
      "tax_id_if_different_from_citizen": "Tax ID (if different from Citizen ID)",
      "email_address": "Email address *",
      "phone_number": "Phone number",
      "use_this_email_as_the_billing": "Use this email as the billing email",
      "billing_information": "Billing information",
      "city_district": "City / District",
      "thailand": "Maldives",
      "additional_information": "Additional information",
      "choose_how_this_supplier_will_receive": "Choose how this supplier will receive their funds.",
      "direct_transfer_to_a_thai_bank": "Direct transfer to a Maldivian bank account",
      "fast_transfer_via_phone_citizen_id": "Fast transfer via Phone, Citizen ID, or Tax ID",
      "promptpay_type": "PromptPay Type",
      "phone_number_2": "Phone Number",
      "citizen_id": "Citizen ID",
      "display_name_for_verification": "Display name (for verification)",
      "invite_supplier_2": "Invite Supplier",
      "enter_a_name_for_this_supplier": "Enter a name for this supplier, then generate a secure link\n                    they can use to provide their identity details, contact\n                    information, and payout method.",
      "supplier_name": "Supplier Name *",
      "generate_invite_link": "Generate Invite Link",
      "secure_link": "Secure Link",
      "copied": "Copied",
      "copy": "Copy",
      "pending_waiting_for_supplier_to_complete": "Pending — Waiting for supplier to complete",
      "funds_source_payin": "Funds Source (Pay-in)",
      "choose_how_you_will_fund_payments": "Choose how you will fund payments to this supplier. Only you can\n                configure this.",
      "acquiring_volume": "Acquiring Volume",
      "use_your_merchant_acquiring_balance_funds": "Use your merchant acquiring balance — funds collected\n                        from customer card payments are used to pay this\n                        supplier",
      "supplier_payments_will_be_deducted_from": "Supplier payments will be deducted from your acquiring\n                      settlement balance before payout. No additional funding\n                      source is needed — your incoming card transaction volume\n                      covers it.",
      "card_payment": "Card Payment",
      "link_your_own_debit_or_credit": "Link your own debit or credit card to fund supplier\n                        payments",
      "your_card_will_be_charged_each": "Your card will be charged each time a payment is made to\n                      this supplier. Card details are stored securely.",
      "name_on_card": "Name on card",
      "expiry_date": "Expiry date",
      "save_supplier": "Save Supplier"
    },
    "SupplierSelfService": {
      "details_submitted_successfully": "Details submitted successfully",
      "thank_you_your_information_has_been": "Thank you! Your information has been sent to Malé Fresh Market Pvt.\n            Ltd. They will review and confirm your details.",
      "you_can_close_this_page": "You can close this page.",
      "attrs": {
        "pomelo": "Pomelo"
      },
      "complete_your_supplier_profile": "Complete your supplier profile",
      "siam_fresh_market_co_ltd_has": "Malé Fresh Market Pvt. Ltd. has invited you to provide your business\n            details and payout information.",
      "company_details_fetched_from_department_of": "Company details fetched from Department of Business\n                            Development (DBD)",
      "choose_how_you_would_like_to": "Choose how you would like to receive your funds.",
      "submit_details": "Submit Details"
    },
    "Suppliers": {
      "suppliers": "Suppliers",
      "upload": "Upload",
      "add_supplier": "Add supplier",
      "all": "All",
      "money_owed_to": "Money owed to",
      "invited": "Invited",
      "show_archived_suppliers": "Show archived suppliers",
      "attrs": {
        "search_by_supplier": "Search by supplier"
      },
      "supplier_detail": "Supplier detail",
      "you_owe_them": "You owe them",
      "no_suppliers_found_matching_your_criteria": "No suppliers found matching your criteria.",
      "supplier_name": "Supplier name",
      "status": "Status",
      "actions": "Actions",
      "pending": "Pending",
      "days_ago": "days ago",
      "copy_link": "Copy link",
      "delete": "Delete",
      "no_pending_invitations": "No pending invitations",
      "invite_a_supplier_by_clicking_add": "Invite a supplier by clicking \"Add supplier\" and\n                            choosing the invite option."
    }
  }
}
